import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../Axios/AxiosInstance';
import './DealerList.css';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import { TableTextConstants, TextConstants } from '../../Constants/Constants';
import ReusableTable from '../../Components/Table/ReusableTable';

const DealerList = () => {
  const { date } = useParams();
  const [dealerData, setDealerData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageDataRef = useRef({});

  const navigate = useNavigate();

  useEffect(() => {
    fetchDealerData();
  }, [date,currentPage,rowsPerPage]);

  const fetchDealerData = async () => {
    const cacheKey = `${currentPage}-${rowsPerPage}`;
    
    if (pageDataRef.current[cacheKey]) {
      setDealerData(pageDataRef.current[cacheKey]);
    } else {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(`/Approval/GetDealerDataByDate?selectedDate=${date}`, {
          params: {
            PageNumber: currentPage,
            PageSize: rowsPerPage,
          },
        });
  
        const { approvalDealerData, paginatedData } = response.data;
  
        if (approvalDealerData && Array.isArray(approvalDealerData)) {
          const formattedData = approvalDealerData.map(item => {
            const [year, month, day] = item.scannedDate.split('T')[0].split('-'); // Extract date parts
            const formattedDate = `${day}/${month}/${year}`; // Rearrange to DD/MM/YYYY
  
            return {
              scannedDate: formattedDate,
              dealerCode: item.dealerCode,
              dealerName: item.dealerName,
              handlingCharges: item.handlingCharges,
              totalAmount: item.totalAmount,
              totalFinalAmount: item.totalFinalAmount,
              dealerId: item.dealerId,
            };
          });
  
          setDealerData(formattedData);
          setTotalRecords(paginatedData.totalRecords);
          pageDataRef.current[cacheKey] = formattedData;
        } else {
          console.error('Data format is incorrect or missing:', approvalDealerData);
        }
      } catch (error) {
        console.error('Error fetching approval data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  

  const columns = [
    { key: 'scannedDate', label: 'Date' },
    { key: 'dealerCode', label: 'Dealer Code' },
    { key: 'dealerName', label: 'Dealer Name' },
    { key: 'totalAmount', label: 'Amount', isTextAlignRight: true, isCurrency: true },
    { key: 'handlingCharges', label: 'Handling Fee', isTextAlignRight: true, isCurrency: true },
    { key: 'totalFinalAmount', label: 'Total Amount', isTextAlignRight: true, isCurrency: true },
  ];

  const handleSelectedRowsChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows);
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const handleEyeClick = (row) => {
    const { dealerId, scannedDate } = row;
    const [day, month, year] = scannedDate.split('/');
    const formattedDate = `${year}-${month}-${day}`;
    navigate(`/painter-list/${formattedDate}/${dealerId}`);
  };

  return (
    <div className="flex flex-col min-h-screen">
     <Header title={`${TextConstants.dealerListTitle}`}/>
     <div className="flex flex-col flex-1 mx-2 my-3">
     <div className="flex justify-end">
        <div className="bg-[#1e365e] text-white px-3.5 py-2 rounded-full shadow-md">
          <span className="text-md">
           Date: {new Date(date).toLocaleDateString('en-GB')}
          </span>
        </div>
      </div>

      <div className="mt-3 p-1">
          <ReusableTable
            data={dealerData}
            columns={columns}
            rowsPerPage={rowsPerPage}
            loading={isLoading}
            currentPage={currentPage}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onSelectedRowsChange={handleSelectedRowsChange}
            enableEye={true}
            onEyeClick={handleEyeClick}
          />
        </div>

     </div>
      <Footer/>
    </div>
  );
};

export default DealerList;
